import * as Yup from "yup";

import { Dispatch, bindActionCreators } from "redux";
import React, { Fragment, useEffect, useState } from "react";
import { maskCEP, maskCelular, maskData, maskTelefone } from "../../utils";

import AdesaoActions from "../../store/ducks/adesao";
import Button from "../../components/Button";
import Error from "../../components/ErrorLabel";
import MaskedInput from "react-text-mask";
import MenuAside from "../../components/MenuAside";
import Progresso from "../../components/Progresso";
import RealizePrev from "../../support";
import { RootState } from "../../store/ducks";
import Titulo from "../../components/Titulo";
import Tooltip from "react-tooltip-lite";
import { connect } from "react-redux";
import moment from "moment";
import translate from "../../i18n";
import { useFormik } from "formik";

interface Props {
  nextStep?: Function;
  previousStep?: Function;
  dadosCadastraisRequest?: Function;
  dadosCadastraisCepRequest?: Function;
  dadosCadastraisAtivoResposta?: Function;
  inserirAdesaoRequest?: Function;
  adesao?: {
    registros?: {
      dadosAdesao?: {
        cpf: string;
        nome: string;
        nomeSocial?: string;
        cpfParticipante: string;
        idParentesco: number;
        idTipoPlano: string;
        valorContribuicao: string;
        idPatrocinador: string;
        cpfParticipanteIndicante: string;
        indcAtualizacaoContribuicaoAnual: string;
      };
      dadosCadastraisEndereco: {
        endereco: {
          idLogredouro: string;
          descLogradouro: string;
          descBairro: string;
          descCidade: string;
          descUf: string;
          numero: string;
          complemento: string;
          cep: string;
        };
      };
      dadosCadastraisPreInfo: {
        nacionalidade: [
          {
            idNacionalidade: number;
            codNacionalidade: number;
            descNacionalidade: string;
            idPais: number;
          }
        ];
        estadoCivil: [
          {
            idEstadoCivil: number;
            codEstadoCivil: number;
            descEstadoCivil: string;
          }
        ];
        uf: [
          {
            idUF: number;
            idPais: number;
            codUF: string;
            descUF: string;
          }
        ];
      };
      dadosCadastrais: {
        pessoa: {
          rg: {
            numero: string;
            orgaoExpedidor: string;
            uf: string;
            dataExpedicao: string;
          };
          cnh: {
            numero: string;
            orgaoExpedidor: string;
            uf: string;
            dataExpedicao: string;
          };
          email: string;
          telefone: string;
          celular: string;
          nacionalidade: string;
          estadoCivil: string;
          sexo: string;
          dataNascimento: string;
          nomeFiliacao1: string;
          nomeFiliacao2: string;
        };
      };
    };
    error: {
      errorCadastro: string;
      errorCEP: string;
    };
  };
}

interface IInserirAdesao {
  cpf: string;
  indParticipante: string;
  nome: string;
  nomeSocial?: string;
  idPatrocinador: any;
  idTipoPlano: any;
  valorContribuicao: any;
  idNacionalidade: any;
  dataNascimento: any;
  sexo: any;
  idEstadoCivil: any;
  nomeMae: any;
  idTipoEndereco: any;
  idLogradouro: any;
  numeroLogradouro: any;
  complementoLogradouro: any;
  email: any;
  idUusarioInclusao: any;
  dataInclusao: any;
  idUsuarioAlteracao: any;
  dataAlteracao: any;
  cpfParticipanteIndicante: any;
  idParentesco: any;
  nomePai: any;
  rg: any;
  orgaoEmissorRg: any;
  ufEmissorRg: any;
  dataExpedicaoRg: any;
  numeroCnh: any;
  ufCnh: any;
  dataExpedicaoCnh: any;
  dddFoneResidencial: any;
  numeroFoneResidencial: any;
  dddCelular: any;
  numeroFoneCelular: any;
  indcAprovacao: any;
  dataAprovacao: any;
  idUsuarioAprovacao: any;
  cpfRespFinanceiro: any;
  nomeRespFinanceiro: any;
  nomeSocialRespFinanceiro?: any;
  dataNascRespFinanceiro: any;
  sexoRespFinanceiro: any;
  rgRespFinanceiro: any;
  orgaoEmiRgRespFinanceiro: any;
  ufEmiRgRespFinanceiro: any;
  dataExpRgRespFinanceiro: any;
  numeroCnhRespFinanceiro: any;
  ufCnhRespFinanceiro: any;
  dataExpedicaoCnhRespFinanceiro: any;
  indcConclusaoSolicitacao: any;
  indcAtualizacaoContribuicaoAnual: any;
  idPropostaAdesao: any;
}

const DadosCadastrais: React.FC<Props> = ({
  nextStep,
  previousStep,
  dadosCadastraisRequest,
  dadosCadastraisCepRequest,
  adesao,
  inserirAdesaoRequest,
}) => {
  const [maiorIdade, setMaiorIdade] = useState(false);
  const [menor16Anos, setMenor16Anos] = useState(false);
  const [naoPossueDataExpedicaoRG, setNaoPossueDataExpedicaoRG] =
    useState(false);
  const [containerCNHHoverEnabled, setContainerCNHHoverEnabled] =
    useState(false);

  useEffect(() => {
    dadosCadastraisRequest!();
  }, [dadosCadastraisRequest]);

  /* eslint-disable */
  // prettier-ignore
  useEffect(() => {
    handleEnderecoChange();
  }, [adesao?.registros?.dadosCadastraisEndereco?.endereco]);

  useEffect(() => {
    atualizarCamposNaTela();
  }, [adesao?.registros?.dadosCadastrais]);

  function atualizarCamposNaTela() {
    if (adesao?.registros?.dadosCadastraisEndereco?.endereco?.cep) {
      dadosCadastraisCepRequest!(
        adesao?.registros?.dadosCadastraisEndereco?.endereco?.cep,
        adesao?.registros?.dadosCadastraisEndereco?.endereco?.numero,
        adesao?.registros?.dadosCadastraisEndereco?.endereco?.complemento
      );

      formik.setFieldValue(
        "pessoa.endereco.cep",
        adesao?.registros?.dadosCadastraisEndereco?.endereco?.cep
      );
    }

    if (adesao?.registros?.dadosCadastrais?.pessoa?.dataNascimento) {
      const dataNascimento = moment(
        adesao?.registros?.dadosCadastrais?.pessoa?.dataNascimento
      ).format("DD/MM/YYYY");
      formik.setFieldValue("pessoa.dataNascimento", dataNascimento);

      verificaMaiorIdade(dataNascimento);
      verificaMenor16Anos(dataNascimento);
    }

    formik.setFieldValue(
      "pessoa.estadoCivil",
      adesao?.registros?.dadosCadastrais?.pessoa?.estadoCivil
    );

    formik.setFieldValue(
      "pessoa.email",
      adesao?.registros?.dadosCadastrais?.pessoa?.email
    );
    formik.setFieldValue(
      "pessoa.telefone",
      adesao?.registros?.dadosCadastrais?.pessoa?.telefone
    );
    formik.setFieldValue(
      "pessoa.celular",
      adesao?.registros?.dadosCadastrais?.pessoa?.celular
    );

    if (adesao?.registros?.dadosCadastrais?.pessoa?.nacionalidade) {
      formik.setFieldValue(
        "pessoa.nacionalidade",
        adesao?.registros?.dadosCadastrais?.pessoa?.nacionalidade
      );
    }

    formik.setFieldValue(
      "pessoa.sexo",
      adesao?.registros?.dadosCadastrais?.pessoa?.sexo
    );
    if (adesao?.registros?.dadosCadastrais?.pessoa?.nomeFiliacao1) {
      formik.setFieldValue("pessoa.filiacao1", "mae");
      formik.setFieldValue(
        "pessoa.nomeFiliacao1",
        adesao?.registros?.dadosCadastrais?.pessoa?.nomeFiliacao1
      );
    }
    if (adesao?.registros?.dadosCadastrais?.pessoa?.nomeFiliacao2) {
      formik.setFieldValue("pessoa.filiacao2", "pai");
      formik.setFieldValue(
        "pessoa.nomeFiliacao2",
        adesao?.registros?.dadosCadastrais?.pessoa?.nomeFiliacao2
      );
    }

    formik.setFieldValue(
      "pessoa.rg.numero",
      adesao?.registros?.dadosCadastrais?.pessoa?.rg.numero
    );
    if (adesao?.registros?.dadosCadastrais?.pessoa?.rg.dataExpedicao) {
      formik.setFieldValue(
        "pessoa.rg.dataExpedicao",
        moment(
          adesao?.registros?.dadosCadastrais?.pessoa?.rg.dataExpedicao
        ).format("DD/MM/YYYY")
      );
    }
    formik.setFieldValue(
      "pessoa.rg.orgaoExpedidor",
      adesao?.registros?.dadosCadastrais?.pessoa?.rg.orgaoExpedidor
    );
    formik.setFieldValue(
      "pessoa.rg.uf",
      adesao?.registros?.dadosCadastrais?.pessoa?.rg.uf
    );
    if (adesao?.registros?.dadosCadastrais?.pessoa?.cnh.numero) {
      formik.setFieldValue(
        "pessoa.cnh.numero",
        adesao?.registros?.dadosCadastrais?.pessoa?.cnh.numero
      );
    }
    if (adesao?.registros?.dadosCadastrais?.pessoa?.cnh.dataExpedicao) {
      formik.setFieldValue(
        "pessoa.cnh.dataExpedicao",
        moment(
          adesao?.registros?.dadosCadastrais?.pessoa?.cnh.dataExpedicao
        ).format("DD/MM/YYYY")
      );
    }
    formik.setFieldValue(
      "pessoa.cnh.uf",
      adesao?.registros?.dadosCadastrais?.pessoa?.cnh.uf
    );
  }

  function verificaMaiorIdade(dataNascimento: any) {
    if (
      moment(dataNascimento, "DD/MM/YYYY")
        .add(18, "year")
        .isSameOrBefore(moment(new Date()))
    ) {
      setMaiorIdade(true);
      formik.setFieldValue("pessoa.maiorIdade", "true");
      formik.setFieldValue("pessoa.endereco.maiorIdade", "true");
    } else {
      setMaiorIdade(false);
      formik.setFieldValue("pessoa.maiorIdade", "false");
      formik.setFieldValue("pessoa.endereco.maiorIdade", "false");
    }
  }

  function verificaMenor16Anos(dataNascimento: any) {
    if (
      moment(dataNascimento, "DD/MM/YYYY")
        .add(16, "year")
        .isSameOrBefore(moment(new Date()))
    ) {
      setMenor16Anos(false);
    } else {
      setMenor16Anos(true);
    }
  }

  function handleIdadeChange(event: any) {
    formik.handleChange(event);

    if (event.target.value.substr(9, 1) != "_") {
      verificaMaiorIdade(event.target.value);
      verificaMenor16Anos(event.target.value);
    } else {
      setMaiorIdade(false);
      setMenor16Anos(false);
    }
  }

  function handleCepChange(event: any) {
    formik.handleChange(event);
    formik.setFieldValue("pessoa.endereco.endereco", "");
    formik.setFieldValue("pessoa.endereco.bairro", "");
    formik.setFieldValue("pessoa.endereco.estado", "");
    formik.setFieldValue("pessoa.endereco.cidade", "");
    if (event.target.value.substr(8, 1) != "_") {
      dadosCadastraisCepRequest!(
        event.target.value.replace("-", ""),
        formik.values.pessoa.endereco.numero,
        formik.values.pessoa.endereco.complemento
      );
    }
  }

  function handleEnderecoChange() {
    formik.setFieldValue(
      "pessoa.endereco.endereco",
      adesao?.registros?.dadosCadastraisEndereco?.endereco?.descLogradouro
    );
    formik.setFieldValue(
      "pessoa.endereco.bairro",
      adesao?.registros?.dadosCadastraisEndereco?.endereco?.descBairro
    );
    formik.setFieldValue(
      "pessoa.endereco.estado",
      adesao?.registros?.dadosCadastraisEndereco?.endereco?.descUf
    );
    formik.setFieldValue(
      "pessoa.endereco.cidade",
      adesao?.registros?.dadosCadastraisEndereco?.endereco?.descCidade
    );
    if (adesao?.registros?.dadosCadastraisEndereco?.endereco?.numero) {
      formik.setFieldValue(
        "pessoa.endereco.numero",
        adesao?.registros?.dadosCadastraisEndereco?.endereco?.numero
      );
    }

    if (adesao?.registros?.dadosCadastraisEndereco?.endereco?.complemento) {
      formik.setFieldValue(
        "pessoa.endereco.complemento",
        adesao?.registros?.dadosCadastraisEndereco?.endereco?.complemento
      );
    }
  }

  const formik = useFormik({
    initialValues: {
      pessoa: {
        nacionalidade: "",
        dataNascimento: "",
        maiorIdade: false,
        sexo: "",
        estadoCivil: "",
        filiacao1: "",
        nomeFiliacao1: "",
        filiacao2: "",
        nomeFiliacao2: "",
        email: "",
        telefone: "",
        celular: "",
        rg: {
          rgObrigatorio: true,

          numero: "",
          orgaoExpedidor: "",
          uf: "",
          dataExpedicao: "",
        },
        cnh: {
          cnhObrigatorio: false,

          numero: "",
          orgaoExpedidor: "",
          uf: "",
          dataExpedicao: "",
        },
        endereco: {
          maiorIdade: false,
          cep: "",
          endereco: "",
          numero: "",
          complemento: "",
          bairro: "",
          estado: "",
          cidade: "",
        },
      },
    },
    validateOnChange: false,

    validateOnBlur: false,
    validationSchema: Yup.object({
      pessoa: Yup.object({
        nacionalidade: Yup.number().required(
          translate.t("app.mensagem.validacaoNacionalidade")
        ),
        dataNascimento: Yup.string().required(
          translate.t("app.mensagem.validacaoDataNascimento")
        ),
        sexo: Yup.string().required(translate.t("app.mensagem.validacaoSexo")),
        estadoCivil: Yup.number().required(
          translate.t("app.mensagem.validacaoEstadoCivil")
        ),
        filiacao1: Yup.string().required(
          translate.t("app.mensagem.validacaoFiliacao1")
        ),
        nomeFiliacao1: Yup.string().required(
          translate.t("app.mensagem.validacaoNomeFiliacao1")
        ),
        maiorIdade: Yup.boolean(),
        email: Yup.string().when("maiorIdade", {
          is: true,
          then: (s: any) =>
            s
              .required(translate.t("app.mensagem.validacaoEmail"))
              .email(translate.t("app.mensagem.validacaoEmailInvalido")),
        }),
        /*celular: Yup.string().when("maiorIdade", {
          is: true,
          then: (s: any) =>
            s.required(translate.t("app.mensagem.validacaoCelular")),
        }),*/
        cnh: Yup.object({
          cnhObrigatorio: Yup.boolean(),

          numero: Yup.string().when("cnhObrigatorio", {
            is: true,
            then: (s: any) =>
              s.required(translate.t("app.mensagem.validacaoCnh.numero")),
          }),
          dataExpedicao: Yup.string().when("cnhObrigatorio", {
            is: true,
            then: (s: any) =>
              s.required(
                translate.t("app.mensagem.validacaoCnh.dataExpedicao")
              ),
          }),
        }),
        rg: Yup.object({
          rgObrigatorio: Yup.boolean(),

          numero: Yup.string().when("rgObrigatorio", {
            is: true,
            then: (s: any) =>
              s.required(translate.t("app.mensagem.validacaoRg.numero")),
          }),

          dataExpedicao: Yup.string().when("rgObrigatorio", {
            is: true,
            then: (s: any) =>
              s.required(translate.t("app.mensagem.validacaoRg.dataExpedicao")),
          }),
        }),
        endereco: Yup.object({
          maiorIdade: Yup.boolean(),
          cep: Yup.string().when("maiorIdade", {
            is: true,
            then: (s: any) =>
              s.required(translate.t("app.mensagem.validacaoEndereco.cep")),
          }),
          numero: Yup.string().when("maiorIdade", {
            is: true,
            then: (s: any) =>
              s.required(translate.t("app.mensagem.validacaoEndereco.numero")),
          }),
          endereco: Yup.string().when("maiorIdade", {
            is: true,
            then: (s: any) =>
              s.required(
                translate.t("app.mensagem.validacaoEndereco.endereco")
              ),
          }),
          bairro: Yup.string().when("maiorIdade", {
            is: true,
            then: (s: any) =>
              s.required(translate.t("app.mensagem.validacaoEndereco.bairro")),
          }),
          estado: Yup.string().when("maiorIdade", {
            is: true,
            then: (s: any) =>
              s.required(translate.t("app.mensagem.validacaoEndereco.estado")),
          }),
          cidade: Yup.string().when("maiorIdade", {
            is: true,
            then: (s: any) =>
              s.required(translate.t("app.mensagem.validacaoEndereco.cidade")),
          }),
        }),
      }),
    }),
    onSubmit: (values) => {
      if (
        menor16Anos &&
        sessionStorage.getItem("@RealizePrev:tipoParticipante") ===
          "AssociadoEspecial"
      ) {
        formik.setFieldError(
          "pessoa.dataNascimento",
          "Não pode ser menor de 16 anos"
        );
        return;
      }
      if (nextStep) {
        sessionStorage.setItem(
          "@RealizePrev:maiorIdade",
          maiorIdade ? "true" : "false"
        );
        const participante =
          sessionStorage.getItem("@RealizePrev:tipoParticipante") ===
          "Participante";

        const associadoEspecial =
          sessionStorage.getItem("@RealizePrev:tipoParticipante") ===
          "AssociadoEspecial";

        let inserirAdesao = {
          cpf: adesao?.registros?.dadosAdesao?.cpf,
          indParticipante: participante ? "S" : "N", // S ou N
          nome: adesao?.registros?.dadosAdesao?.nome,
          nomeSocial: adesao?.registros?.dadosAdesao?.nomeSocial,
          idPatrocinador: adesao?.registros?.dadosAdesao?.idPatrocinador,
          idTipoPlano: adesao?.registros?.dadosAdesao?.idTipoPlano,
          valorContribuicao: adesao?.registros?.dadosAdesao?.valorContribuicao,
          idNacionalidade: formik.values.pessoa.nacionalidade,
          dataNascimento: formik.values.pessoa.dataNascimento,
          sexo: formik.values.pessoa.sexo,
          idEstadoCivil: formik.values.pessoa.estadoCivil,
          nomeMae:
            formik.values.pessoa.filiacao1 === formik.values.pessoa.filiacao2
              ? formik.values.pessoa.nomeFiliacao1
              : formik.values.pessoa.filiacao1 === "mae"
              ? formik.values.pessoa.nomeFiliacao1
              : formik.values.pessoa.nomeFiliacao2,
          nomePai:
            formik.values.pessoa.filiacao1 === formik.values.pessoa.filiacao2
              ? formik.values.pessoa.nomeFiliacao2
              : formik.values.pessoa.filiacao2 === "pai"
              ? formik.values.pessoa.nomeFiliacao2
              : formik.values.pessoa.nomeFiliacao1,
          idTipoEndereco: "1",
          idLogradouro: maiorIdade
            ? adesao?.registros?.dadosCadastraisEndereco.endereco.idLogredouro
            : 0,
          numeroLogradouro: maiorIdade
            ? formik.values.pessoa.endereco.numero
            : null,
          complementoLogradouro: maiorIdade
            ? formik.values.pessoa.endereco.complemento
            : null,
          email: maiorIdade ? formik.values.pessoa.email : null,
          idUusarioInclusao: RealizePrev().idUsuario,
          dataInclusao: moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
          idUsuarioAlteracao: RealizePrev().idUsuario,
          dataAlteracao: moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
          cpfParticipanteIndicante:
            participante || associadoEspecial
              ? null
              : adesao?.registros?.dadosAdesao?.cpfParticipanteIndicante,
          idParentesco:
            participante || associadoEspecial
              ? null
              : adesao?.registros?.dadosAdesao?.idParentesco,

          rg: formik.values.pessoa.rg.numero,
          orgaoEmissorRg: formik.values.pessoa.rg.orgaoExpedidor,
          ufEmissorRg: formik.values.pessoa.rg.uf,
          dataExpedicaoRg: formik.values.pessoa.rg.dataExpedicao,
          numeroCnh: formik.values.pessoa.cnh.numero,
          ufCnh: formik.values.pessoa.cnh.uf,
          dataExpedicaoCnh: formik.values.pessoa.cnh.dataExpedicao,
          // ocupacaoPrincipal: '',
          dddFoneResidencial: maiorIdade
            ? formik.values.pessoa.telefone &&
              formik.values.pessoa.telefone.length >= 14
              ? formik.values.pessoa.telefone
                  .substr(1, 3)
                  .replace("_", "")
                  .replace("_", "")
                  .replace("_", "")
              : null
            : null,
          numeroFoneResidencial: maiorIdade
            ? formik.values.pessoa.telefone &&
              formik.values.pessoa.telefone.length >= 14
              ? formik.values.pessoa.telefone
                  .substr(6, formik.values.pessoa.telefone.length - 6)
                  .replace("_", "")
                  .replace("_", "")
                  .replace("-", "")
              : null
            : null,
          dddCelular: maiorIdade
            ? formik.values.pessoa.celular &&
              formik.values.pessoa.celular.length >= 14
              ? formik.values.pessoa.celular
                  .substr(1, 3)
                  .replace("_", "")
                  .replace("_", "")
                  .replace("_", "")
              : null
            : null,
          numeroFoneCelular: maiorIdade
            ? formik.values.pessoa.celular &&
              formik.values.pessoa.celular.length >= 14
              ? formik.values.pessoa.celular
                  .substr(6, formik.values.pessoa.celular.length - 6)
                  .replace("_", "")
                  .replace("_", "")
                  .replace("-", "")
              : null
            : null,
          indcAprovacao: "",
          dataAprovacao: "",
          idUsuarioAprovacao: "",
          cpfRespFinanceiro: "",
          nomeRespFinanceiro: "",
          dataNascRespFinanceiro: "",
          sexoRespFinanceiro: "",
          //idEstCivilRespFinanceiro: "",
          //nomePaiRespFinanceiro: "",
          //nomeMaeRespFinanceiro: "",
          rgRespFinanceiro: "",
          orgaoEmiRgRespFinanceiro: "",
          ufEmiRgRespFinanceiro: "",
          dataExpRgRespFinanceiro: "",
          numeroCnhRespFinanceiro: "",
          ufCnhRespFinanceiro: "",
          dataExpedicaoCnhRespFinanceiro: "",
          nomeSocialRespFinanceiro: null,
          indcConclusaoSolicitacao: "N",
          indcAtualizacaoContribuicaoAnual:
            adesao?.registros?.dadosAdesao?.indcAtualizacaoContribuicaoAnual,
        } as IInserirAdesao;

        if (inserirAdesao.nomeSocialRespFinanceiro === null) {
          delete inserirAdesao["nomeSocialRespFinanceiro"];
        }

        if (inserirAdesao.nomeSocial === null) {
          delete inserirAdesao["nomeSocial"];
        }

        inserirAdesaoRequest!(inserirAdesao, maiorIdade);
      }
    },
  });

  /* eslint-disable */
  // prettier-ignore
  useEffect(() => {
    if(maiorIdade){
    if(formik.values.pessoa.cnh.numero 
      || formik.values.pessoa.cnh.dataExpedicao){
      formik.setFieldValue("pessoa.cnh.cnhObrigatorio", "true");
      formik.setFieldValue("pessoa.rg.rgObrigatorio", "false");
    } else{
      formik.setFieldValue("pessoa.rg.rgObrigatorio", "true");
      formik.setFieldValue("pessoa.cnh.cnhObrigatorio", "false");
    }
  }else{
    formik.setFieldValue("pessoa.rg.rgObrigatorio", "false");
    formik.setFieldValue("pessoa.cnh.cnhObrigatorio", "false");
  }
 
  }, [maiorIdade,formik.values.pessoa.rg.numero, formik.values.pessoa.rg.dataExpedicao, formik.values.pessoa.cnh.numero, formik.values.pessoa.cnh.dataExpedicao]);

  function handleNaoPossueDataExpedicaoRG(event: any) {
    event.preventDefault();
    setNaoPossueDataExpedicaoRG(true);
    formik.setFieldValue("pessoa.cnh.naoPossueDataExpedicaoRG", "true");
  }
  return (
    <Fragment>
      <div className="content wrapper">
        <MenuAside step={2} />
        <form onSubmit={formik.handleSubmit}>
          <div className="container">
            <h2>{translate.t("app.tela.dadosCadastrais.titulo")}</h2>

            <div className="pb-4  mb-4 mt-4">
              <div
                className="row"
                style={{
                  marginTop: "1.2rem",
                }}
              >
                <div className="col-lg-3">
                  <div className="form-group relative">
                    <label>
                      {translate.t(
                        "app.tela.dadosCadastrais.label.nacionalidade"
                      )}
                    </label>
                    <div>
                      <select
                        name="pessoa.nacionalidade"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.pessoa.nacionalidade}
                        disabled={
                          !!adesao?.registros?.dadosCadastrais?.pessoa
                            .nacionalidade
                        }
                      >
                        <option value="">SELECIONE</option>
                        {adesao?.registros?.dadosCadastraisPreInfo?.nacionalidade?.map(
                          (nacionalidade: any, indice) => {
                            return (
                              <option
                                key={nacionalidade.idNacionalidade}
                                value={nacionalidade.idNacionalidade}
                              >
                                {nacionalidade.descNacionalidade}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                    <Error error={formik.errors.pessoa?.nacionalidade} />
                  </div>
                </div>

                <div className="col-lg-3">
                  <div className="form-group relative">
                    <label>
                      {translate.t(
                        "app.tela.dadosCadastrais.label.dataNascimento"
                      )}
                    </label>
                    <MaskedInput
                      type="text"
                      datatype="dd/mm/yyyy"
                      disabled={
                        !!adesao?.registros?.dadosCadastrais?.pessoa
                          .dataNascimento
                      }
                      name="pessoa.dataNascimento"
                      onChange={handleIdadeChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.pessoa.dataNascimento}
                      className="form-control"
                      mask={maskData}
                    />
                    <Error error={formik.errors.pessoa?.dataNascimento} />
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="form-group relative">
                    <label>
                      {translate.t("app.tela.dadosCadastrais.label.sexo")}
                    </label>
                    <div>
                      <select
                        name="pessoa.sexo"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.pessoa.sexo}
                        disabled={
                          !!adesao?.registros?.dadosCadastrais?.pessoa.sexo
                        }
                      >
                        <option value="">SELECIONE</option>
                        <option value="M">Masculino</option>
                        <option value="F">Feminino</option>
                      </select>
                    </div>
                    <Error error={formik.errors.pessoa?.sexo} />
                  </div>
                </div>

                <div className="col-lg-3">
                  <div className="form-group relative">
                    <label>
                      {translate.t(
                        "app.tela.dadosCadastrais.label.estadoCivil"
                      )}
                    </label>
                    <div>
                      <select
                        name="pessoa.estadoCivil"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.pessoa.estadoCivil}
                        disabled={
                          !!adesao?.registros?.dadosCadastrais?.pessoa
                            .estadoCivil
                        }
                      >
                        <option value="">SELECIONE</option>
                        {adesao?.registros?.dadosCadastraisPreInfo?.estadoCivil?.map(
                          (estadoCivil: any, indice) => {
                            return (
                              <option
                                key={estadoCivil.idEstadoCivil}
                                value={estadoCivil.idEstadoCivil}
                              >
                                {estadoCivil.descEstadoCivil}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                    <Error error={formik.errors.pessoa?.estadoCivil} />
                  </div>
                </div>
              </div>

              <div
                className="row"
                style={{
                  marginTop: "1.2rem",
                }}
              >
                <div className="col-lg-3">
                  <div className="form-group relative">
                    <label>
                      {translate.t("app.tela.dadosCadastrais.label.filiacao1")}
                    </label>
                    <div>
                      <select
                        name="pessoa.filiacao1"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.pessoa.filiacao1}
                        disabled={
                          !!adesao?.registros?.dadosCadastrais?.pessoa
                            .nomeFiliacao1
                        }
                      >
                        <option value="">SELECIONE</option>
                        <option value="mae">Mãe</option>
                        <option value="pai">Pai</option>
                      </select>
                    </div>
                    <Error error={formik.errors.pessoa?.filiacao1} />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group relative">
                    <label>
                      {translate.t("app.tela.dadosCadastrais.label.nome1")}
                    </label>

                    <input
                      type="text"
                      name="pessoa.nomeFiliacao1"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.pessoa.nomeFiliacao1}
                      className="form-control"
                      disabled={
                        !!adesao?.registros?.dadosCadastrais?.pessoa
                          .nomeFiliacao1
                      }
                    />
                    <Error error={formik.errors.pessoa?.nomeFiliacao1} />
                  </div>
                </div>
              </div>

              <div
                className="row"
                style={{
                  marginTop: "1.2rem",
                }}
              >
                <div className="col-lg-3">
                  <div className="form-group relative">
                    <label>
                      {translate.t("app.tela.dadosCadastrais.label.filiacao2")}
                    </label>
                    <div>
                      <select
                        name="pessoa.filiacao2"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.pessoa.filiacao2}
                        disabled={
                          !!adesao?.registros?.dadosCadastrais?.pessoa
                            .nomeFiliacao2
                        }
                      >
                        <option value="">SELECIONE</option>
                        <option value="mae">Mãe</option>
                        <option value="pai">Pai</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group relative">
                    <label>
                      {translate.t("app.tela.dadosCadastrais.label.nome2")}
                    </label>

                    <input
                      type="text"
                      name="pessoa.nomeFiliacao2"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.pessoa.nomeFiliacao2}
                      className="form-control"
                      disabled={
                        !!adesao?.registros?.dadosCadastrais?.pessoa
                          .nomeFiliacao2
                      }
                    />
                  </div>
                </div>
              </div>

              <div
                className="row"
                style={{
                  marginTop: "1.2rem",
                }}
              >
                <div className="col-lg-2">
                  <div className="form-group relative">
                    <label>
                      {translate.t("app.tela.dadosCadastrais.label.rg.numero")}
                    </label>

                    <input
                      type="text"
                      name="pessoa.rg.numero"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.pessoa.rg.numero}
                      className="form-control"
                      disabled={
                        !!adesao?.registros?.dadosCadastrais?.pessoa.rg.numero
                      }
                    />
                    <Error error={formik.errors.pessoa?.rg?.numero} />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="form-group relative">
                    <label>
                      {translate.t(
                        "app.tela.dadosCadastrais.label.rg.orgaoExpedidor"
                      )}
                    </label>

                    <input
                      type="text"
                      name="pessoa.rg.orgaoExpedidor"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.pessoa.rg.orgaoExpedidor}
                      className="form-control"
                      disabled={
                        !!adesao?.registros?.dadosCadastrais?.pessoa.rg
                          .orgaoExpedidor
                      }
                    />
                    <Error error={formik.errors.pessoa?.rg?.orgaoExpedidor} />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="form-group relative">
                    <label>
                      {translate.t("app.tela.dadosCadastrais.label.rg.uf")}
                    </label>
                    <div>
                      <select
                        name="pessoa.rg.uf"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.pessoa.rg.uf}
                        disabled={
                          !!adesao?.registros?.dadosCadastrais?.pessoa.rg.uf
                        }
                      >
                        <option value="">SELECIONE</option>
                        {adesao?.registros?.dadosCadastraisPreInfo?.uf?.map(
                          (uf: any, indice) => {
                            return (
                              <option key={uf.codUF} value={uf.codUF}>
                                {uf.descUF}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                    <Error error={formik.errors.pessoa?.rg?.uf} />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="form-group relative">
                    <label>
                      {translate.t(
                        "app.tela.dadosCadastrais.label.rg.dataExpedicao"
                      )}
                    </label>

                    <MaskedInput
                      type="text"
                      name="pessoa.rg.dataExpedicao"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.pessoa.rg.dataExpedicao}
                      className="form-control"
                      disabled={
                        !!adesao?.registros?.dadosCadastrais?.pessoa.rg
                          .dataExpedicao
                      }
                      mask={maskData}
                    />
                    <Error error={formik.errors.pessoa?.rg?.dataExpedicao} />
                  </div>
                </div>
                <div onClick={handleNaoPossueDataExpedicaoRG}>
                  <a href="#" className="btn btn--primary">
                    <small className="font-weight-bolder">
                      {translate.t("app.botao.naoPossuoDataExpedicao")}
                    </small>
                  </a>
                </div>
              </div>

              {naoPossueDataExpedicaoRG && (
                <Fragment>
                  <div className="opcaorg" id="opcaorg">
                    <div
                      className="row"
                      style={{
                        marginTop: "1.2rem",
                      }}
                    >
                      <div className="col-lg-3">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            border: containerCNHHoverEnabled
                              ? "1px solid #17a2b8"
                              : "1px dashed",
                            borderRadius: "5px",
                            paddingRight: "10px",
                          }}
                          className="form-group relative"
                          onMouseEnter={() => setContainerCNHHoverEnabled(true)}
                          onMouseLeave={() =>
                            setContainerCNHHoverEnabled(false)
                          }
                        >
                          <label style={{ cursor: "pointer" }}>
                            {translate.t(
                              "app.tela.dadosCadastrais.label.cnh.numero"
                            )}
                          </label>
                          <input
                            style={{
                              border: "none",
                              outline: "none",
                              boxShadow: "none",
                            }}
                            type="text"
                            name="pessoa.cnh.numero"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.pessoa.cnh.numero}
                            className="form-control"
                            disabled={
                              !!adesao?.registros?.dadosCadastrais?.pessoa.cnh
                                .numero
                            }
                          />
                          <div style={{ display: "none" }} />
                          <Tooltip
                            className="ml-2"
                            background="black"
                            color="white"
                            content={
                              <p>
                                {translate.t(
                                  "app.tela.dadosCadastrais.label.cnh.tooltip.linha1"
                                )}
                                <br />
                                {translate.t(
                                  "app.tela.dadosCadastrais.label.cnh.tooltip.linha2"
                                )}
                                <br />
                                {translate.t(
                                  "app.tela.dadosCadastrais.label.cnh.tooltip.linha3"
                                )}
                                <br />
                                {translate.t(
                                  "app.tela.dadosCadastrais.label.cnh.tooltip.linha4"
                                )}
                                <br />
                                {translate.t(
                                  "app.tela.dadosCadastrais.label.cnh.tooltip.linha5"
                                )}
                                <br />
                                {translate.t(
                                  "app.tela.dadosCadastrais.label.cnh.tooltip.linha6"
                                )}
                              </p>
                            }
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="#17a2b8"
                              viewBox="0 0 24 24"
                              style={{ cursor: "pointer" }}
                            >
                              <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 18.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25c.691 0 1.25.56 1.25 1.25s-.559 1.25-1.25 1.25zm1.961-5.928c-.904.975-.947 1.514-.935 2.178h-2.005c-.007-1.475.02-2.125 1.431-3.468.573-.544 1.025-.975.962-1.821-.058-.805-.73-1.226-1.365-1.226-.709 0-1.538.527-1.538 2.013h-2.01c0-2.4 1.409-3.95 3.59-3.95 1.036 0 1.942.339 2.55.955.57.578.865 1.372.854 2.298-.016 1.383-.857 2.291-1.534 3.021z"></path>
                            </svg>
                          </Tooltip>

                          <Error error={formik.errors.pessoa?.cnh?.numero} />
                        </div>
                      </div>

                      <div className="col-lg-2">
                        <div className="form-group relative">
                          <label>
                            {translate.t(
                              "app.tela.dadosCadastrais.label.cnh.orgaoExpedidor"
                            )}
                          </label>

                          <input
                            type="text"
                            name="pessoa.cnh.orgaoExpedidor"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.pessoa.cnh.orgaoExpedidor}
                            className="form-control"
                            disabled={
                              !!adesao?.registros?.dadosCadastrais?.pessoa.cnh
                                .orgaoExpedidor
                            }
                          />
                        </div>
                      </div>

                      <div className="col-lg-2">
                        <div className="form-group relative">
                          <label>
                            {translate.t(
                              "app.tela.dadosCadastrais.label.cnh.uf"
                            )}
                          </label>
                          <div>
                            <select
                              name="pessoa.cnh.uf"
                              className="form-control"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.pessoa.cnh.uf}
                              disabled={
                                !!adesao?.registros?.dadosCadastrais?.pessoa.cnh
                                  .uf
                              }
                            >
                              <option value="">SELECIONE</option>
                              {adesao?.registros?.dadosCadastraisPreInfo?.uf?.map(
                                (uf: any, indice) => {
                                  return (
                                    <option key={uf.codUF} value={uf.codUF}>
                                      {uf.descUF}
                                    </option>
                                  );
                                }
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="form-group relative">
                          <label>
                            {translate.t(
                              "app.tela.dadosCadastrais.label.cnh.dataExpedicao"
                            )}
                          </label>

                          <MaskedInput
                            type="text"
                            name="pessoa.cnh.dataExpedicao"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.pessoa.cnh.dataExpedicao}
                            className="form-control"
                            disabled={
                              !!adesao?.registros?.dadosCadastrais?.pessoa.cnh
                                .dataExpedicao
                            }
                            mask={maskData}
                          />

                          <Error
                            error={formik.errors.pessoa?.cnh?.dataExpedicao}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Fragment>
              )}

              {maiorIdade && (
                <Fragment>
                  <div
                    className="row"
                    style={{
                      marginTop: "1.2rem",
                    }}
                  >
                    <div className="col-lg-3">
                      <div className="form-group relative">
                        <label>
                          {translate.t(
                            "app.tela.dadosCadastrais.label.endereco.cep"
                          )}
                        </label>
                        <MaskedInput
                          type="text"
                          name="pessoa.endereco.cep"
                          onChange={handleCepChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.pessoa.endereco.cep}
                          className="form-control"
                          mask={maskCEP}
                          disabled={
                            !!adesao?.registros?.dadosCadastraisEndereco
                              ?.endereco?.cep
                          }
                        />
                        <Error error={formik.errors.pessoa?.endereco?.cep} />

                        <Error error={adesao?.error.errorCEP} />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group relative">
                        <label>
                          {translate.t(
                            "app.tela.dadosCadastrais.label.endereco.endereco"
                          )}
                        </label>
                        <input
                          type="text"
                          value={formik.values.pessoa.endereco.endereco}
                          name="pessoa.endereco.endereco"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className="form-control"
                          disabled
                        />
                        <Error
                          error={formik.errors.pessoa?.endereco?.endereco}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group relative">
                        <label>
                          {translate.t(
                            "app.tela.dadosCadastrais.label.endereco.numero"
                          )}
                        </label>
                        <input
                          type="text"
                          name="pessoa.endereco.numero"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.pessoa.endereco.numero}
                          className="form-control"
                          disabled={
                            !!adesao?.registros?.dadosCadastraisEndereco
                              ?.endereco?.numero
                          }
                        />
                        <Error error={formik.errors.pessoa?.endereco?.numero} />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group relative">
                        <label>
                          {" "}
                          {translate.t(
                            "app.tela.dadosCadastrais.label.endereco.complemento"
                          )}
                        </label>
                        <input
                          type="text"
                          name="pessoa.endereco.complemento"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.pessoa.endereco.complemento}
                          className="form-control"
                          disabled={
                            !!adesao?.registros?.dadosCadastraisEndereco
                              ?.endereco?.complemento
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className="row"
                    style={{
                      marginTop: "1.2rem",
                    }}
                  >
                    <div className="col-lg-4">
                      <div className="form-group relative">
                        <label>
                          {translate.t(
                            "app.tela.dadosCadastrais.label.endereco.bairro"
                          )}
                        </label>
                        <input
                          type="text"
                          disabled
                          name="pessoa.endereco.bairro"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.pessoa.endereco.bairro}
                          className="form-control"
                        />
                        <Error error={formik.errors.pessoa?.endereco?.bairro} />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group relative">
                        <label>
                          {translate.t(
                            "app.tela.dadosCadastrais.label.endereco.estado"
                          )}
                        </label>
                        <input
                          type="text"
                          value={formik.values.pessoa.endereco.estado}
                          name="pessoa.endereco.uf"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className="form-control"
                          disabled
                        />
                        <Error error={formik.errors.pessoa?.endereco?.estado} />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group relative">
                        <label>
                          {translate.t(
                            "app.tela.dadosCadastrais.label.endereco.cidade"
                          )}
                        </label>
                        <input
                          type="text"
                          value={formik.values.pessoa.endereco.cidade}
                          name="pessoa.endereco.cidade"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className="form-control"
                          disabled
                        />
                        <Error error={formik.errors.pessoa?.endereco?.cidade} />
                      </div>
                    </div>
                  </div>

                  <div
                    className="row"
                    style={{
                      marginTop: "1.2rem",
                    }}
                  >
                    <div className="col-lg-4">
                      <div className="form-group relative">
                        <label>
                          {translate.t("app.tela.dadosCadastrais.label.email")}
                        </label>
                        <input
                          type="text"
                          name="pessoa.email"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.pessoa.email}
                          className="form-control"
                          disabled={
                            !!adesao?.registros?.dadosCadastrais?.pessoa?.email
                          }
                        />
                        <Error error={formik.errors.pessoa?.email} />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group relative">
                        <label>
                          {translate.t(
                            "app.tela.dadosCadastrais.label.telefone"
                          )}
                        </label>
                        <MaskedInput
                          type="text"
                          name="pessoa.telefone"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.pessoa.telefone}
                          className="form-control"
                          mask={maskTelefone}
                          disabled={
                            !!adesao?.registros?.dadosCadastrais?.pessoa
                              ?.telefone
                          }
                        />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group relative">
                        <label>
                          {translate.t(
                            "app.tela.dadosCadastrais.label.celular"
                          )}
                        </label>
                        <MaskedInput
                          type="text"
                          name="pessoa.celular"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.pessoa.celular}
                          className="form-control"
                          mask={maskCelular}
                          disabled={
                            !!adesao?.registros?.dadosCadastrais?.pessoa
                              ?.celular
                          }
                        />
                        <Error error={formik.errors.pessoa?.celular} />
                      </div>
                    </div>
                  </div>
                </Fragment>
              )}

              <div className="row">
                <div className="col-lg-12">
                  <p>
                    <small>
                      <em>{translate.t("app.mensagem.camposObrigatorios")}</em>
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="membership__pagination text-center mt-3">
            <Error error={adesao?.error.errorCadastro} />
          </div>

          <div className="membership__pagination text-center mt-3">
            <Button previousStep={previousStep ? previousStep : () => {}} />
            <Button avancar previousStep={() => {}} />
          </div>
        </form>
      </div>
    </Fragment>
  );
};
const mapStateToProps = (state: RootState) => ({
  adesao: state.adesao,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(AdesaoActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DadosCadastrais);
